export const WEB_VERSION='2.0.0'